<template>
    <v-container fluid class="scroll-y fullscreen accent" pa-0>
        <v-card
            class="mx-auto"
            flat
            :loading="loading"
            loader-height="10"
            tile
        >
            <v-toolbar
            color="#003a6f"
            dark
            flat
            >
                <v-toolbar-title>{{ pageTitleFull }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <Stats :stats="stats" v-if="routeKey == 'all'"/>
                <v-btn
                    :loading="loading3"
                    :disabled="loading3"
                    color="#ffffff"
                    class="primary--text"
                    @click="newMail = !newMail" 
                    tile
                    small
                    v-if="selectedItems.length > 0"
                    >
                        New Mail
                </v-btn>
                <v-btn
                    :loading="loading3"
                    :disabled="loading3"
                    color="#ffffff"
                    class="primary--text"
                    @click="drawer = !drawer" 
                    tile
                    small
                    v-if="routeKey != 'new'"
                    >
                        Filter
                </v-btn>
            </v-toolbar>
            <v-toolbar
            color="#0c477c"
            dark
            flat
            height="40"
            >
                <v-spacer></v-spacer>
                <v-toolbar-title class="lead-count" >
                     {{ selectedItems.length > 0 ? selectedItems.length + ' Leads Selected.' : total + ' Leads Found.' }}
                </v-toolbar-title>
                <v-btn class="ml-3" tile color="primary" small v-if="selectedItems.length > 0" @click="selectAll">Select All</v-btn>
                <v-btn class="primary--text" tile color="#ffffff" small v-if="selectedItems.length > 0" @click="deselectAll">Deselect All</v-btn>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-list two-line tile flat class="py-0 primary">
                <v-list-item-group
                    v-model="selectedItems"
                    multiple
                >
                    <template v-for="(lead, index) in leads">
                        <v-list-item
                        :key="`lead-${index}`"
                        :value="lead.id"                 
                        >
                            <template v-slot:default="{ active, toggle }">
                                <v-list-item-action class="mr-2">
                                    <v-checkbox
                                        :input-value="active"
                                        :true-value="lead.id"
                                        @click="toggle"
                                        dark
                                    ></v-checkbox>
                                </v-list-item-action>
                                <v-list-item-content @click.stop="openLead(lead.id)">
                                    <v-list-item-title class="white--text" v-html="lead.title"></v-list-item-title>
                                    <v-list-item-subtitle class="white--text" v-html="lead.city+ ', ' + lead.state + ' - ' + lead.county + ' County'"></v-list-item-subtitle>
                                    <v-list-item-subtitle class="white--text" v-if="lead.approved_at != null">Approved {{ lead.approved_at | moment("from", "now") }}</v-list-item-subtitle>
                                    <v-list-item-subtitle class="white--text" v-else>Updated {{ lead.updated_at | moment("from", "now") }}</v-list-item-subtitle>
                                    <div v-if="lead.status.length > 0">
                                        <v-chip
                                        class="mr-2 mb-1"
                                        :color="getColor(lead.status.value)"
                                        text-color="white"
                                        small
                                        label
                                        >
                                        {{ lead.status.label }}
                                        </v-chip>
                                    </div>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-list-item-icon class="ma-0 mb-1">
                                        <v-btn small tile class="mr-1" elevation="0" color="light-blue" dark @click.stop="openLink(lead.google_link)">
                                            <v-icon dark>mdi-map-marker</v-icon>
                                        </v-btn>

                                        <v-btn small tile class="mr-1" color="#003a6f" elevation="0" dark @click.stop="dial(lead.phone)">
                                            <v-icon dark>mdi-phone</v-icon>
                                        </v-btn>

                                        <v-btn small tile color="#005baf" elevation="0" dark @click.stop="sendmail(lead.email)">
                                            <v-icon dark>mdi-email</v-icon>
                                        </v-btn>
                                    </v-list-item-icon>
                                    <v-list-item-icon class="ma-0 w-100" v-if="routeKey != 'my'">
                                        <v-btn small disabled v-if="lead.estimator" tile dark>{{ lead.estimator.name }}</v-btn>
                                        <v-btn small color="secondary" v-else :to="`/schedule/`+lead.id" tile elevation="0">Assign/Schedule</v-btn>
                                    </v-list-item-icon>
                                    <v-list-item-icon v-else class="ma-0 w-100">
                                        <v-btn small :to="`/schedule/`+lead.id" tile elevation="0" v-if="lead.schedule">{{ lead.schedule | moment("MMMM Do hh:mm a") }}</v-btn>
                                        <v-btn small color="secondary" v-else :to="`/schedule/`+lead.id" tile elevation="0">Schedule</v-btn>
                                    </v-list-item-icon>
                                </v-list-item-action>
                            </template>
                        </v-list-item>
                        <v-divider
                        :key="`dv-${index}`"
                        ></v-divider>
                    </template>
                </v-list-item-group>
                <v-list-item v-if="pagination.total > 1" class="accent">
                    <v-list-item-content>
                        <v-pagination
                            v-model="pagination.current"
                            :length="pagination.total"
                            @input="onPageChange"
                            :total-visible="totalVisible"
                            dark
                        ></v-pagination>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-card>
        <FilterDrawer :show="drawer" :filter="filter" :routekey="routeKey" @update-schedule="updateSchedule" @update-estimator="updateEstimator" @update-status="updateStatus" @update-assign="updateAssign" @update-drawer="updateDrawer" @update-keyword="updateKeyword" @update-phone="updatePhone" @update-daterange="updateDaterange" @submit-search="submitSearch"/>
        <Mail :show="newMail" :recepients="selectedItems" @close-mail="newMail = false"/>
    </v-container>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import FilterDrawer from '../components/LeadsFilter.vue'
import Mail from '../components/Mail.vue'
import Stats from '../components/Stats.vue'

export default {
    data() {
        return {
            newMail: false,
            selectedItems: [],
            drawer: false,
            loading: true,
            leads: [],
            pagination: {
                current: 1,
                total: 0
            },
            totalVisible: 5,
            pageTitle: '',
            apiUrl: '',
            routeKey: '',
            filter: {
                schedule: "all",
                estimator: "all",
                status: "all",
                assign: "all",
                keyword: "",
                phone: "",
                daterange: ""
            },
            total: 0,
            all: [],
            stats: []
        }
    },
    watch: {
        filter: {
            deep: true,

            handler(newValue) {
                this.$store.commit('SET_LEADS_FILTER', newValue)
            }
        }
    },
    created() {
        this.pageTitle = this.$route.meta.title
        this.apiUrl = this.$route.meta.api
        this.routeKey = this.$route.meta.key
        if(this.$store.state.filter.leads) {
            this.filter = this.$store.state.filter.leads
        }
        this.getLeads()
    },
    computed: {
        ...mapGetters({
            statuses: 'data/statusArray',
            estimators: 'data/estimators',
            schedules: 'data/schedulesArray',
            assignitems: 'data/assignArray'
        }),
        pageTitleFull() {
            if(this.loading == true) {
                return 'Loading...'
            } else if(this.searchQuery.length > 0) {
                return this.searchQuery.join(' - ')
            } else {
                return this.pageTitle
            }
        },
        searchQuery() {
            let titles = []

            let status = this.statuses.filter(status => {
                return status.value == this.filter.status
            })

            if(status.length > 0 && status[0].value != 'all') {
                titles.push(status[0].label)
            }

            let assign =  this.assignitems.filter(assign => {
                return assign.value == this.filter.assign
            })

            if(assign.length > 0 && assign[0].value != 'all') {
                titles.push(assign[0].label)
            }

            let schedule =  this.schedules.filter(schedule => {
                return schedule.value == this.filter.schedule
            })

            if(schedule.length > 0 && schedule[0].value != 'all') {
                titles.push(schedule[0].label)
            }

            let estimator = this.estimators.filter(estimator => {
                return estimator.id == this.filter.estimator
            })

            if(estimator.length > 0) {
                titles.push(estimator[0].name)
            }

            return titles
        }
    },
    components: {
        FilterDrawer,
        Mail,
        Stats
    },
    methods: {
        getLeads() {
            this.loading = true
            //this.drawer = false
            axios.get(this.apiUrl + this.pagination.current, {
                params: this.filter
            })
            .then(response => {
                this.loading = false
                this.leads = response.data.data
                this.pagination.current = response.data.submissions.current_page
                this.pagination.total = response.data.submissions.last_page
                this.total = response.data.submissions.total
                this.all = response.data.all
                this.stats = response.data.stats
                this.$nextTick()
            })
        },
        onPageChange() {
            this.getLeads()
            this.$vuetify.goTo(0)
        },
        openLead(id) {
            this.$router.push({ path: '/lead/'+id })
        },
        selectAll() {
            this.selectedItems = this.all
        },
        deselectAll() {
            this.selectedItems = []
        },
        dial (number) {
            window.location ='tel:'+number;
        },
        sendmail (address ){
            window.location = 'mailto:'+address;
        },
        openLink (link) {
            window.open(link, "_blank") || window.location.replace(link)
        },
        updateSchedule(val) {
            this.filter.schedule = val
            this.getLeads()
        },
        updateEstimator(val) {
            this.filter.estimator = val
            this.getLeads()
        },
        updateStatus(val) {
            this.filter.status = val
            this.getLeads()
        },
        updateAssign(val) {
            this.filter.assign = val
            this.getLeads()
        },
        updateDrawer(val) {
            this.drawer = val
        },
        updateKeyword(val) {
            this.filter.keyword = val
        },
        updatePhone(val) {
            this.filter.phone = val
        },
        updateDaterange(val) {
            this.filter.daterange = val
        },
        submitSearch() {
            this.getLeads()
        },
        getColor(status) {
            switch(status) {
                case 'considering':
                    return 'light-blue'
                case 'confirmed':
                    return 'green'
                case 'sold':
                    return 'purple'
                case 'revisit':
                    return 'orange'
                case 'lost':
                    return 'red'
                case 'still_out_of_budget':
                    return '#9f9f9f'
                case 'cost_is_higher':
                    return '#9f9f9f'
                default:
                    // code block
            }
        },
        selectItem (id) {
            if (this.selectedItems.includes(id)) {
                this.selectedItems.splice(this.selectedItems.indexOf(id), 1);
            } else {
                this.selectedItems.push(id);
            }
        }
    }
}
</script>
<style lang="sass" scoped>
.theme--light 
    .v-content
        background: #ffffff

.fullscreen
    background: #fff
    height: 100%

.w-100
    width: 100%
    .v-btn 
        width: 100%

.v-list-item__action
    .v-btn
        &:not(.v-btn--round)
            &.v-size--small
                height: 42px

.v-chip 
    border-radius: 0!important

.lead-count
    font-size: 14px
</style>